import dayjs from "dayjs";

export function getError(error) {
  try {
    return error.response.data.data.error;
  } catch (err) {
    return "undefined";
  }
}

let passIconMap = {
  flower: "flower-market.svg",
  general: "shopping-bag.svg",
  general_and_flower: "general_flower.svg"
};

let passColorMap = {
  flower: "icon-color-flower",
  general: "icon-color-primary",
  general_and_flower: "icon-color-secondary"
};

let passRadioColorMap = {
  flower: "radio-flower",
  general: "radio-primary",
  general_and_flower: "radio-secondary"
};

export function centsToDollars(cents) {
  return (cents / 100).toFixed(2);
}

export function filterValid(passes) {
  return passes.filter(pass => {
    return !pass.renewed && dayjs(pass.expires_at).diff(dayjs()) > 0;
  });
}

export default {
  pass: {
    getIcon: function(id) {
      if (!passIconMap.hasOwnProperty(id)) return "";

      return require("@/assets/icons/" + passIconMap[id]);
    },
    getColor: function(id) {
      if (!passIconMap.hasOwnProperty(id)) return "";

      return passColorMap[id];
    },
    getRadioColor(id) {
      if (!passIconMap.hasOwnProperty(id)) return "";

      return passRadioColorMap[id];
    }
  },
  user: {
    hasPermission(user, permission) {
      return user.permissions.includes(permission);
    }
  }
};
